import React, {Component} from 'react';
import { Col, Row, Tabs,Tab,  FormControl} from 'react-bootstrap';
import FileDownload from 'shared/FileDownload';
import moment   from 'moment'

import json2csv   from 'json2csv'


import Select   from 'react-select'
 import {prepareSelectOptionsList,filterFocusAreaOptions, filterFocusAreaSelectedOptions} from 'util/Utils';
 const allReportFieldList = [
     {label: 'Create Date', value:'createdAt'},
     {label: 'Fulfilled Date', value:'FulfilledAt.Date'},
     {label: 'Customer', value:'UserFullName'},
     {label: 'Email', value:'email'},
    {label: 'Status', value:'Status'},
    {label: 'Order Number', value:'OrderNumber'},
    {label: 'Messages', value:'Messages'},
    {label: '4 Days Reminder', value:'Reminder'},
     {label: 'User Response', value:'UserResponse'},
     {label: 'Create Date', value:'createdAt'},

]

export default class AdminOrdersActionsBox extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);


        this.state = {
             pending: false,
            recordIDs:[],
            reportFields: [

                {label: 'Order Number', value:'OrderNumber'},
                {label: 'Customer', value:'UserFullName'},
                {label: 'Email', value:'UserID.email'},
                {label: 'Status', value:'Status'},
                {label: 'Create Date', value:'createdAt'},
                {label: 'Shopify Link', value:'ShopifyOrderLink'},
                {label: 'Fulfilled Date', value:'FulfilledDate'},
                {label: '4 Days Reminder', value:'WarehousePickupReminderSentData'},
                {label: 'User Response', value:'WarehousePickupUserResponseData'},
                {label: 'Create Date', value:'createdAt'},
                {label: 'Messages', value:'Messages'},
                {label: 'Change Log', value:'ChangeLogs'},
            ]
         };

    };





    onSelectTab(event){
        this.setState({displayReportTab:!this.state.displayReportTab})
    }
    render() {

        // if (_.size(self.state.filterOptions.ageGroup) >0 ){
        //     ageRanges.unshift({value: false, label: 'All groups'});
        //  }
        return (
            <div className="action-block">

                <Tabs defaultActiveKey={''}  onSelect={(e)=>{this.onSelectTab(e)}} id="userActionBox" >

                    <Tab eventKey={'reports'} className={this.state.displayReportTab ? '' : 'hidden'}
                         unmountOnExit={true} title="Reports">
                        <Row className="show-grid">
                            <Col md={4} xs={4} className="top10">
                                <Select
                                    tabIndex="0"
                                    searchable={true}
                                    multi
                                    selectedOptions
                                    clearable={false}
                                    placeholder="Included fields"
                                    options={allReportFieldList}
                                    onChange={ (selectedOptions) => this.setState({'reportFields': selectedOptions})}
                                    //  filterOptions={filterOptions}
                                    value={this.state.reportFields}
                                />
                            </Col>
                        </Row>
                        <Row>

                            <Col md={3} xs={6} className="top10">
                                <button className="btn btn-primary" disabled={this.state.pending}
                                        onClick={ ()=>this.props.downloadReport({reportFields:this.state.reportFields})}
                                        type="button">
                                    Download report
                                </button>


                            </Col>
                        </Row>
                    </Tab>

                    </Tabs>

                </div >
        );

    }
}



